"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageViewedEventCard = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ViewerAvatar_1 = require("Analytics/Page/Components/ViewerAvatar");
var Utils_1 = require("Analytics/Page/Utils");
var LocationFlag_1 = require("Analytics/Page/Components/LocationFlag");
var SessionInfoLine_1 = require("Analytics/Page/Components/SessionInfoLine");
var VerifiedPill_1 = require("Analytics/Page/Components/VerifiedPill");
var LinkedInSearch_1 = require("Analytics/Page/Components/LinkedInSearch");
var styles = __importStar(require("./SummaryTimeline.css"));
var PageViewedEventCard = function (_a) {
    var _b = _a.eventData, session = _b.session, viewer = _b.viewer, onOpenSessionClick = _a.onOpenSessionClick;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween" },
            react_1.default.createElement(kaleidoscope_1.Heading, { className: styles.engagementHeading, strong: true, level: "5" }, "Page viewed"),
            react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () { return onOpenSessionClick(viewer, session.pageViewId); }, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small }, "View session")),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "xs" },
            react_1.default.createElement(ViewerAvatar_1.ViewerAvatar, { viewer: viewer, size: kaleidoscope_1.AvatarSize.Small }),
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s" }, viewer.displayName),
            viewer.isVerified && react_1.default.createElement(VerifiedPill_1.VerifiedPill, null),
            react_1.default.createElement(LinkedInSearch_1.LinkedInSearch, { viewer: viewer })),
        react_1.default.createElement("div", { className: styles.pageViewCardDivider }),
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxs" },
            react_1.default.createElement(SessionInfoLine_1.SessionInfoLine, { title: "Email", IconType: icons_1.Mail, info: viewer.email, textSize: "xs" }),
            react_1.default.createElement(SessionInfoLine_1.SessionInfoLine, { title: "Duration", IconType: icons_1.Clock, info: (0, Utils_1.formatCompactViewDuration)(session.duration), textSize: "xs" }),
            react_1.default.createElement(SessionInfoLine_1.SessionInfoLine, { title: "Location", iconElement: react_1.default.createElement(LocationFlag_1.LocationFlag, { countryCode: session.countryCode }), info: session.location, textSize: "xs" }))));
};
exports.PageViewedEventCard = PageViewedEventCard;
